import * as JsSearch from "js-search";
import { SearchedBlog } from "../contexts/search";

type ReturnType = {
  search: (q: string, b: SearchedBlog[]) => Queries.NodeForBlogIndexFragment[];
};

export default function useJsSearch(): ReturnType {
  const dataToSearch = new JsSearch.Search("id");
  dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy();
  dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer();
  dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("id");

  dataToSearch.addIndex(["frontmatter", "title"]);
  dataToSearch.addIndex(["frontmatter", "author"]);
  dataToSearch.addIndex(["frontmatter", "tags"]);
  dataToSearch.addIndex(["frontmatter", "description"]);
  dataToSearch.addIndex("longExcerpt");

  const search = (
    query: string,
    blogs: SearchedBlog[]
  ): Queries.NodeForBlogIndexFragment[] => {
    dataToSearch.addDocuments(blogs);

    return dataToSearch.search(query) as Queries.NodeForBlogIndexFragment[];
  };

  return { search };
}
